import { cn } from "@/lib/utils";

interface RequiredMarkProps {
  className?: string;
}

/**
 * The "*" next to a required field's label. Single source of truth for its
 * color — this exact marker was previously three different colors across the
 * wizard (Tailwind's default red, the brand's primary red, and a one-off hex
 * that didn't match either), including plain dark text in a couple of spots
 * that made it look like part of the label instead of a required indicator.
 */
export function RequiredMark({ className }: RequiredMarkProps) {
  return (
    <span className={cn("text-primary", className)} aria-label="required">
      *
    </span>
  );
}
